/**
 * CE Accordion
 */
jQuery(".ce_accordion .accordion-toggle").on("click", function () {
    jQuery(this).toggleClass('active');
    jQuery(this).next().stop().slideToggle();
});
